<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records cart-section h-100">
            <div class="row h-100">
                <div class="col-12 mb-4 Order Confirmed h-100">
                    <div class="bg-white border-radius-5 p-5 Order h-100">
                        <div class="card border-0">
                            <div class="card-body p-0">
                                <div class="row justify-content-center order-confirmed pt-3">
                                    <div class="col-md-5 text-center">
                                        <figure class="mb-4"><img src="../../../../static/website/images/prescription-list-saved.svg" alt="" /></figure>
                                        <p>your prescription list has been saved. You can analyze and order your medicine from prescription list.</p>
                                        <router-link class="btn btn-blue Prescription" to="/prescription">Go to Prescription List</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "prescription-list-saved",
        data() {
            return {};
        },
        created(){
           this.pageName('Prescription')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription-list-saved.vue